var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6c10b0cb37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.5 115.363281 L 262.5 115.363281 L 262.5 259.363281 L 112.5 259.363281 Z M 112.5 115.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7ca6d0b577"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.769531 112.5 L 256.769531 112.5 L 256.769531 262.5 L 112.769531 262.5 Z M 112.769531 112.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c10b0cb37)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(5.769231, 0, 0, 5.758452, 112.499997, 115.382966)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.599948 23.586228 L 24.186095 0.999862 ",
    stroke: "#a3a3a3",
    strokeWidth: 2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ca6d0b577)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.000000000000000353, 5.769231, -5.758452, 0.000000000000000353, 256.751793, 112.498389)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 1.600227 23.585888 L 24.185697 1.0002 ",
    stroke: "#a3a3a3",
    strokeWidth: 2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/IconClose.411fa95947efb130452ddeaeccf26665.svg";
export { ForwardRef as ReactComponent };